import { useCallback, useEffect, useRef, useState } from "react";
import { useAdBlock } from "../hooks/useAdBlock";
import Icon from "./icons";

// AdBlockUyari — panelin tamamında görünen uyarı bandı.
//
// Reklam engelleyiciler bu panelde yalnızca reklamı değil, ÖLÇÜM uçlarını da
// keser: yolunda "tracking" geçen istekler (Mail Takibi listesi, canlı SSE
// akışı, ziyaret detayı) sessizce düşer. Sessizce — hata mesajı çıkmaz,
// sayfa boş ya da donuk görünür. Bu yüzden uyarı kapatılabilir ama
// varsayılan olarak açıktır.
//
// Band TEK SATIRDIR (2026-08-10): her sayfanın en üstünde durduğu için dört
// satırlık açıklama içerik alanının üstünü yiyordu. Bandda yalnız teşhis
// cümlesi kalır; gerekçe, etkilenen yüzeyler ve çözüm ⓘ düğmesinin açtığı
// modalde. Metin kısalmadı, yalnız YERİ değişti — engelleyicinin neyi kestiği
// hâlâ tam yazıyor, çünkü kullanıcı aksi hâlde boş listeyi hata sanıyor.
export default function AdBlockUyari() {
  const durum = useAdBlock();
  const [kapali, setKapali] = useState(false);
  const [acik, setAcik] = useState(false);
  const kutuRef = useRef<HTMLDivElement>(null);
  const infoRef = useRef<HTMLButtonElement>(null);

  const kapat = useCallback(() => setAcik(false), []);

  useEffect(() => {
    if (!acik) return;
    // Odak modale girsin, kapanınca ⓘ düğmesine geri dönsün — klavye kullanıcısı
    // sayfanın başına savrulmamalı.
    const onceki = document.activeElement as HTMLElement | null;
    kutuRef.current?.querySelector<HTMLElement>("button")?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") { e.stopPropagation(); kapat(); return; }
      if (e.key !== "Tab") return;
      // Basit odak tuzağı: Tab kutunun dışına çıkmasın.
      const oge = kutuRef.current?.querySelectorAll<HTMLElement>("button:not([disabled]), [href]");
      if (!oge || oge.length === 0) return;
      const ilk = oge[0];
      const son = oge[oge.length - 1];
      if (e.shiftKey && document.activeElement === ilk) { e.preventDefault(); son.focus(); }
      else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
    };
    document.addEventListener("keydown", onKey, true);
    return () => {
      document.removeEventListener("keydown", onKey, true);
      (onceki ?? infoRef.current)?.focus?.();
    };
  }, [acik, kapat]);

  if (durum !== "engelli" || kapali) return null;

  return (
    <>
      <div className="adblock-bar" role="alert">
        <span className="adblock-ico"><Icon name="alert" size={17} /></span>
        <strong className="adblock-text">
          Reklam engelleyici algılandı — panel eksik çalışıyor.
        </strong>
        <button
          ref={infoRef}
          type="button"
          className="adblock-btn"
          onClick={() => setAcik(true)}
          aria-haspopup="dialog"
          aria-label="Ayrıntıları göster"
          title="Ayrıntı"
        >
          <Icon name="info" size={17} />
        </button>
        <button
          type="button"
          className="adblock-btn adblock-close"
          onClick={() => setKapali(true)}
          aria-label="Uyarıyı kapat"
          title="Kapat"
        >
          <Icon name="close" size={16} />
        </button>
      </div>

      {acik && (
        <div
          className="modal-overlay"
          onMouseDown={(e) => { if (e.target === e.currentTarget) kapat(); }}
        >
          <div
            className="modal-box"
            ref={kutuRef}
            role="dialog"
            aria-modal="true"
            aria-labelledby="adblock-baslik"
          >
            <div className="modal-head">
              <span className="adblock-ico"><Icon name="alert" size={18} /></span>
              <h2 id="adblock-baslik">Reklam engelleyici algılandı</h2>
            </div>
            <div className="modal-body">
              <p>
                Eklenti, adresinde <code>tracking</code> geçen istekleri kesiyor.
                Bundan etkilenenler: <strong>canlı güncelleme (SSE)</strong>, Mail
                Takibi listesi ve ziyaret detayları — üstelik hata vermeden, sessizce.
              </p>
              <p>
                Tüm işlevleri doğru kullanabilmek için bu site
                (<code>{location.host}</code>) için engelleyiciyi kapatın ya da beyaz
                listeye alın, sonra sayfayı yenileyin.
              </p>
              <p>
                <em>Ziyaretçi ölçümünün kendisi etkilenmez</em> — o sunucu tarafında
                yapılır; engellenen yalnız panelin veriyi okuması.
              </p>
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-soft" onClick={kapat}>Kapat</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
